import { Component } from 'react';
import { Portal } from '~/features/common';
import isFeatureEnabled from '~/components/common/is-feature-enabled';
// API:
// id: unique identifier for a particular message
// message: main text to display
// undoCallback (optional): function to call when undo is clicked, undo option will only be shown if this property is provided
// locateUrl (optional): if provided, include a link to this url
// duration (optional): time in ms to display the message, default: 1000ms
// position (optional): where to place the message, default: bottom-left
import ActionMessages, { ActionMessageTypes } from './action-messages';
import ActionMessage from './action-message';

/** @deprecated prefer `import { useToast } from '@workramp/ui';` */
export default class ActionMessageContainer extends Component {
  constructor(props) {
    super(props);

    this.state = { id: 0, lifespan: 0 };
  }

  componentDidMount() {
    if (ActionMessages.isLoaded) {
      console.error('Action messages already loaded.');
      return;
    }

    ActionMessages.generateMessage = ({
      message,
      undoCallback,
      locateUrl,
      duration,
      position,
      type = ActionMessageTypes.default,
    }) => {
      this.setState({
        id: this.state.id + 1,
        message,
        undoCallback,
        locateUrl,
        duration,
        position,
        type,
      });
    };

    ActionMessages.isLoaded = true;

    const intervalId = setInterval(this.handleTimer, 1000);
    this.setState({ intervalId });
  }

  componentDidUpdate(prevProps, prevState) {
    const duration = this.state.duration || 4000;

    if (prevState.id !== this.state.id) {
      this.setState({
        lifespan: duration,
      });
    }
  }

  render() {
    const useNewUiux = isFeatureEnabled('uiux_refresh__action_messages');
    const isLifespan = this.state.lifespan > 0;
    const visibilityClass = isLifespan ? 'action-message--visible' : 'action-message--hide';
    const positionClass = this.getPositionClass();
    const styleOverride = {};
    if (this.state.type !== ActionMessageTypes.default) {
      styleOverride.backgroundColor = (() => {
        if (this.state.type === ActionMessageTypes.warning) {
          return '#FFD542';
        }
        if (this.state.type === ActionMessageTypes.error) {
          return '#FD6864';
        }
      })();
    }

    return (
      <Portal aria-hidden={!isLifespan}>
        {!useNewUiux && (
          <div
            ref={(message) => {
              this.message = message;
            }}
            className={`action-message ${visibilityClass} ${positionClass}`}
            style={styleOverride}
            aria-hidden={!isLifespan}
          >
            <div className="action-message--element action-message--text">{this.state.message}</div>
            {this.getLocateLink()}
            {this.getUndoLink()}
            <img
              className="action-message--element action-message--dismiss"
              src="/images/cross_icon_dark_blue.svg"
              alt=""
              aria-hidden="true"
              onClick={this.dismissMessage}
            />
          </div>
        )}

        {useNewUiux && (
          <ActionMessage
            isVisible={isLifespan}
            message={this.state.message}
            position={this.state.position}
            type={this.state.type}
            onDismiss={this.dismissMessage}
            onUndo={this.state.undoCallback && this.handleUndoClick}
            locateUrl={this.state.locateUrl}
          />
        )}
      </Portal>
    );
  }

  getUndoLink = () => {
    const { undoCallback } = this.state;
    if (typeof undoCallback === 'function') {
      return (
        <div
          className="action-message--element action-message--link action-message--undo"
          onClick={this.handleUndoClick}
        >
          Undo
        </div>
      );
    }
  };

  getLocateLink = () => {
    const { locateUrl } = this.state;
    if (locateUrl) {
      return (
        <div
          onClick={function () {
            location.href = locateUrl;
          }}
          className="action-message--element action-message--link action-message--locate"
        >
          Locate
        </div>
      );
    }
  };

  handleUndoClick = (e) => {
    e.preventDefault();
    this.state.undoCallback();
  };

  dismissMessage = (e) => {
    e.preventDefault();
    this.setState({
      lifespan: 0,
    });
  };

  getPositionClass = () => {
    switch (this.state.position) {
      case 'bottomRight':
        return 'action-message--bottom-right';
      case 'topRight':
        return 'action-message--top-right';
      case 'topLeft':
        return 'action-message--top-left';
      default:
        return 'action-message--bottom-left';
    }
  };

  handleTimer = () => {
    const me = this;
    const { lifespan } = this.state;
    if (lifespan > 0) {
      this.setState({ lifespan: lifespan - 1000 });
    }
  };
}
